import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=06202182&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=06202182&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06202182",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1955189871/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06202182')) {
      api.createRecord('06202182', component.options)
    } else {
      api.reload('06202182', component.options)
    }
    module.hot.accept("./VideoPlayer.vue?vue&type=template&id=06202182&scoped=true", function () {
      api.rerender('06202182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/VideoPlayer.vue"
export default component.exports